export enum ETipoRelacaoCadastro {
    Segurado = 1,
}
